module.exports = __webpack_public_path__ + "media/fitness-coach.7fc615c3.mp4";